module.exports = __webpack_public_path__ + "img/my.myb59320d.svg";